export default __webpack_public_path__ + "static/diplomats_Mediator_INFP_career_path-ea04804da88996133f86c5f15e3ca1ca.svg";